import {Order, OrderSearchParams, Transaction} from "../models/order";
import {clone} from "lodash";
import * as moment from "moment";
import {
    ORDERS_API_ERROR,
    ORDERS_DECRYPTED_TRANS,
    ORDERS_DETAIL_LOADED,
    ORDERS_DETAIL_UPDATE,
    ORDERS_EMAIL_SENT,
    ORDERS_LOADED,
    ORDERS_LOADING,
    ORDERS_SET_KEY,
    ORDERS_UPDATE_SEARCH_PARAMS,
    OrdersAction
} from "../actions/orders";
import {LOCAL_DATE_FMT, localStorageGet, localStorageSet} from "../utils";

export interface OrdersState {
    orderSearchParams: OrderSearchParams;
    orderList: Order[];
    orderDetail?: Order;
    loading: boolean;
    errorMessage?: string;
    decryptionKey?: string;
    decryptedTransactions?: Transaction[];
}

const LS_KEY_KEY = "__ls_key_key";

const initialState = (): OrdersState => {
    const key = localStorageGet(LS_KEY_KEY);
    return {
        loading: false,
        orderList: [],
        orderSearchParams: {
            minDate: moment().add(-1, 'month').format(LOCAL_DATE_FMT),
            maxDate: moment().add(1, 'days').format(LOCAL_DATE_FMT),
        },
        decryptionKey: key
    };
};

export function ordersReducer(state: OrdersState = initialState(), action: OrdersAction): OrdersState {
    switch (action.type) {
        case ORDERS_LOADING:
            return {
                ...state,
                loading: true,
                errorMessage: null
            } as OrdersState;
        case ORDERS_LOADED:
            return {
                ...state,
                loading: false,
                errorMessage: null,
                orderList: action.orderList,
                decryptedTransactions: null,
            } as OrdersState;
        case ORDERS_DETAIL_LOADED:
            return {
                ...state,
                loading: false,
                errorMessage: null,
                orderDetail: action.orderDetail,
                decryptedTransactions: null,
            } as OrdersState;
        case ORDERS_API_ERROR:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage
            } as OrdersState;
        case ORDERS_UPDATE_SEARCH_PARAMS:
            return {
                ...state,
                orderSearchParams: action.orderSearchParams
            } as OrdersState;
        case ORDERS_DECRYPTED_TRANS:
            return {
                ...state,
                loading: false,
                decryptedTransactions: action.transactions,
            } as OrdersState;
        case ORDERS_SET_KEY:
            localStorageSet(LS_KEY_KEY, action.key);
            return {
                ...state,
                decryptionKey: action.key
            } as OrdersState;
        case ORDERS_EMAIL_SENT:
            return {
                ...state,
                loading: false,
                errorMessage: null
            } as OrdersState;
        case ORDERS_DETAIL_UPDATE:
            return {
                ...state,
                orderDetail: action.orderDetail
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/orders.ts